import { StartupService } from "../services/startup.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { SchedulerComponent } from "./scheduler.component";
import { DayPilotModule } from "daypilot-pro-angular";
import { HttpClientModule } from "@angular/common/http";
import { SchedulerUpperComponent } from './scheduler-upper/scheduler-upper.component';
import { EditEventDialogComponent } from './edit-event-dialog/edit-event-dialog.component';
import { MaterialModule } from '.././shared/material.module';
import { DirectivesModule } from "../directives/directives.module";
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    DayPilotModule,
    MaterialModule,
    ReactiveFormsModule,
    DirectivesModule
  ],
  declarations: [
    SchedulerComponent,
    SchedulerUpperComponent,
    EditEventDialogComponent
  ],
  exports: [SchedulerComponent],
  providers: [StartupService, CookieService]
})
export class SchedulerModule { }
